import { creditsRepository } from '@/repositories'

function useListCredits() {
	const { data, isLoading } = creditsRepository.useListQuery()

	return { data, isLoading }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	list: useListCredits,
}
